import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMenuitemComponent } from './app.menuitem.component';
@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitemComponent],
  templateUrl: './app.menu.component.html',
  styles: ``,
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  ngOnInit() {
    this.model = [
      {
        label: 'การจัดการผู้ดูแลระบบ',
        icon: 'pi pi-home',
        items: [
          {
            label: 'จัดการผู้ใช้งาน',
            icon: 'pi pi-fw pi-user',
            routerLink: ['/staff/staff-list'],
          },
          {
            label: 'จัดการบทบาท',
            icon: 'pi pi-fw pi-box',
            routerLink: ['/roles/role-list'],
          },
        ],
      },
      { separator: true },
      {
        label: 'การจัดการข้อมูลการตลาด',
        icon: 'pi pi-bullseye',
        items: [
          {
            label: 'Friend Get Friends',
            icon: 'pi pi-fw pi-thumbs-up',
            routerLink: ['/marketing/get-friends'],
          },
          {
            label: 'Affiliate Program',
            icon: 'pi pi-fw pi-thumbs-up',
            routerLink: ['/marketing/get-affiliates'],
          },
        ],
      },
      { separator: true },
      {
        label: 'การจัดการ Privilege',
        icon: 'pi pi-ticket',
        items: [
          {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-chart-pie',
            routerLink: ['/marketing/privilege/dashboard'],
          },
          {
            label: 'รายการ Privilege',
            icon: 'pi pi-fw pi-id-card',
            routerLink: ['/marketing/privilege/list'],
          },
          {
            label: 'สแกน QR (Redeem)',
            icon: 'pi pi-fw pi-qrcode',
            routerLink: ['/marketing/privilege/redeem'],
          },
        ],
      },
      { separator: true },
      {
        label:'การจัดการข้อมูล Lead',
        icon: 'pi pi-bullseye',
        items: [
          {
            label: 'Leads',
            icon: 'pi pi-fw pi-id-card',
            routerLink: ['/lead/lead-list'],
          }
        ],
      },
       { separator: true },
      {
        label: 'การจัดการข้อมูลการจอง',
        icon: 'pi pi-bullseye',
        items: [
          {
            label: 'Dashboard Bookings',
            icon: 'pi pi-fw pi-chart-bar',
            routerLink: ['/bookings/dashboard'],
          },
          {
            label: 'Booking My Prince Cafe',
            icon: 'pi pi-fw pi-ticket',
            routerLink: ['/bookings/booking-list'],
          }
        ],
      },
      { separator: true },
    ];
  }
}
